import type { ListOrdersAdminInput } from '@repo/api-contracts';
import { type ReactElement, useState } from 'react';
import { useNavigate } from 'react-router';
import { useOrdersListQuery } from '@/entities/order';
import { PageHeader } from '@/shared/ui';
import { OrderList } from '@/widgets/order-list';

const DEFAULT_QUERY: ListOrdersAdminInput = {
  page: 1,
  limit: 20,
  filter: 'IN_FULFILLMENT',
  search: '',
};

/**
 * 제작 발주 자료 — 발주할 주문(처리할 건)만 주문 목록 위젯으로 보여 준다. 상태 필터는 숨기고 요청마다 처리할 건으로 고정한다.
 * 행을 열면 주문 상세의 발주서 영역(`#production-order`)으로 간다.
 */
export function ProductionOrdersPage(): ReactElement {
  const navigate = useNavigate();
  const [query, setQuery] = useState<ListOrdersAdminInput>(DEFAULT_QUERY);
  const list = useOrdersListQuery(query);
  return (
    <>
      <PageHeader title="제작 발주 자료" description="결제된 주문의 발주서를 작성·출력합니다." />
      <OrderList
        hideStatusFilter
        data={list.data}
        initialQuery={query}
        onQueryChange={(next) => setQuery({ ...next, filter: 'IN_FULFILLMENT' })}
        onOpen={(orderId) => {
          void navigate(`/orders/${orderId}#production-order`);
        }}
        pending={list.isFetching}
        error={list.isError ? `주문 목록을 불러오지 못했습니다: ${list.error.message}` : null}
      />
    </>
  );
}
